module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAABW0lEQVRIS63WsVXDMBAG4DsXamEDYALYgBXCBEAldTACmYCUlhsnGzBCsolHgFJuxJOf5Zc40vkkObVzXyTf/Tls2/bWGPONiBsA2Ekpt7DSR2u9B4BXa21XVdULaq2PAPDs61tr90qp91LPQ2d1O4fZeeFScA75+ljX9Q4RP9YCYxAAHHB8Z0dEfCwFKUhK+YYOWANcgpwzYKUgB7rAckEudIWlgilQEOOCqVAUY4AdIt4HBv/gui4WCFODhB6gujQVIk/G6dIzkDzRlCCcDHQn7Pu+A4CbwOB3SqkHTh3yGn0BohmGR7hZuogtQf4HcUASI6C/yJWSf09RjJojIcSnMSY5vIMYZ2BzwvsK40CcsQi9wwssBcoBJywHSgUHrARKAd3CM6xbOVk3/85Clm6D25VbTqj0pqKJAH8d5jLvLjVUM8ATNk3zZK39GcHsE0Wu9GtcE09CiM0/wqdigr/tEBEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chahao.png
// module id = QlN+
// module chunks = 1